/**
 * Visual shape variants for the toggler button.
 * - `ROUND`   — plain round div (default when unset).
 * - `BALLOON` — speech-bubble SVG shape.
 * - `CUSTOM`  — user-supplied image (`custom_shape_active` / `custom_shape_inactive`).
 * - `NONE`    — shape is hidden entirely; only the icon (if any) is shown.
 */
export enum ChatTogglerShape {
	ROUND = 'round',
	BALLOON = 'balloon',
	CUSTOM = 'custom',
	NONE = 'none',
}

export type ITogglerButtonShape = {
	/**
	 * Shape for the active (open) toggler state.
	 * Absent / `undefined` → defaults to `ROUND` at runtime.
	 */
	shape_active?: ChatTogglerShape;
	/**
	 * Shape for the inactive (closed) toggler state.
	 * Absent / `undefined` → defaults to `ROUND` at runtime.
	 */
	shape_inactive?: ChatTogglerShape;
	custom_shape_active?: string;
	custom_shape_inactive?: string;
};
export type ITogglerButtonIcon = {
	/**
	 * Custom icon for the active toggler state.
	 * - `string` — URL or data URL of a custom image.
	 * - `false`  — icon explicitly disabled; nothing is rendered (not even the built-in default).
	 * - `undefined` / absent — built-in default icon is shown (backward-compatible).
	 */
	icon_active?: string | false;
	/**
	 * Custom icon for the inactive toggler state.
	 * - `string` — URL or data URL of a custom image.
	 * - `false`  — icon explicitly disabled; nothing is rendered (not even the built-in default).
	 * - `undefined` / absent — built-in default icon is shown (backward-compatible).
	 */
	icon_inactive?: string | false;
};

export type IChatTogglerConfiguration = ITogglerButtonIcon &
	ITogglerButtonShape &
	Partial<{ hidden?: boolean }>;
